// src/services/pescaService.js
import { apiClient } from './api';

const PESCA_BASE = '/pesca';

export const pescaService = {
  // ==================== NAVES ====================
  cargarNaves: (rutEmpresa) =>
    apiClient.get(`${PESCA_BASE}/naves?rut_empresa=${rutEmpresa}`),

  guardarNave: (nave) =>
    apiClient.post(`${PESCA_BASE}/naves`, nave),

  actualizarNave: (naveId, nave) =>
    apiClient.put(`${PESCA_BASE}/naves/${naveId}`, nave),

  // ==================== CARGOS ====================
  cargarCargos: (rutEmpresa) =>
    apiClient.get(`${PESCA_BASE}/cargos?rut_empresa=${rutEmpresa}`),

  guardarCargo: (cargo) =>
    apiClient.post(`${PESCA_BASE}/cargos`, cargo),

  actualizarCargo: (cargoId, cargo) =>
    apiClient.put(`${PESCA_BASE}/cargos/${cargoId}`, cargo),

  eliminarCargo: (cargoId) =>
    apiClient.delete(`${PESCA_BASE}/cargos/${cargoId}`),

  // ==================== TRIPULANTES ====================
  cargarTripulantes: (rutEmpresa, soloActivos = true) =>
    apiClient.get(`${PESCA_BASE}/tripulantes?rut_empresa=${rutEmpresa}&solo_activos=${soloActivos}`),

  guardarTripulante: (tripulante) =>
    apiClient.post(`${PESCA_BASE}/tripulantes`, tripulante),

  actualizarTripulante: (tripulanteId, tripulante) =>
    apiClient.put(`${PESCA_BASE}/tripulantes/${tripulanteId}`, tripulante),

  // ==================== LIQUIDACIONES ====================
  cargarLiquidaciones: (rutEmpresa, anio = null) => {
    let endpoint = `${PESCA_BASE}/liquidaciones?rut_empresa=${rutEmpresa}`;
    if (anio) endpoint += `&anio=${anio}`;
    return apiClient.get(endpoint);
  },

  crearLiquidacion: (liquidacion) =>
    apiClient.post(`${PESCA_BASE}/liquidaciones`, liquidacion),

  obtenerLiquidacion: (id) =>
    apiClient.get(`${PESCA_BASE}/liquidaciones/${id}`),

  actualizarLiquidacion: (id, datos) =>
    apiClient.put(`${PESCA_BASE}/liquidaciones/${id}`, datos),

  eliminarLiquidacion: (id) =>
    apiClient.delete(`${PESCA_BASE}/liquidaciones/${id}`),

  // ==================== CAPTURAS ====================
  agregarCaptura: (liquidacionId, captura) =>
    apiClient.post(`${PESCA_BASE}/liquidaciones/${liquidacionId}/capturas`, captura),

  editarCaptura: (liquidacionId, capturaId, datos) =>
    apiClient.put(`${PESCA_BASE}/liquidaciones/${liquidacionId}/capturas/${capturaId}`, datos),

  eliminarCaptura: (liquidacionId, capturaId) =>
    apiClient.delete(`${PESCA_BASE}/liquidaciones/${liquidacionId}/capturas/${capturaId}`),

  // ==================== GASTOS ====================
  agregarGasto: (liquidacionId, gasto) =>
    apiClient.post(`${PESCA_BASE}/liquidaciones/${liquidacionId}/gastos`, gasto),

  editarGasto: (liquidacionId, gastoId, datos) =>
    apiClient.put(`${PESCA_BASE}/liquidaciones/${liquidacionId}/gastos/${gastoId}`, datos),

  eliminarGasto: (liquidacionId, gastoId) =>
    apiClient.delete(`${PESCA_BASE}/liquidaciones/${liquidacionId}/gastos/${gastoId}`),

  // ==================== VIAJES ====================
  agregarViaje: (liquidacionId, viaje) =>
    apiClient.post(`${PESCA_BASE}/liquidaciones/${liquidacionId}/viajes`, viaje),

  editarViaje: (liquidacionId, viajeId, datos) =>
    apiClient.put(`${PESCA_BASE}/liquidaciones/${liquidacionId}/viajes/${viajeId}`, datos),

  eliminarViaje: (liquidacionId, viajeId) =>
    apiClient.delete(`${PESCA_BASE}/liquidaciones/${liquidacionId}/viajes/${viajeId}`),

  // ==================== DISTRIBUCION ====================
  actualizarDistribucion: (liquidacionId, distribucionId, datos) =>
    apiClient.put(`${PESCA_BASE}/liquidaciones/${liquidacionId}/distribucion/${distribucionId}`, datos),

  // ==================== CALCULO Y ESTADOS ====================
  calcularDistribucion: (liquidacionId) =>
    apiClient.post(`${PESCA_BASE}/liquidaciones/${liquidacionId}/calcular`),

  liquidar: (liquidacionId) =>
    apiClient.post(`${PESCA_BASE}/liquidaciones/${liquidacionId}/liquidar`),

  // ==================== PDF ====================
  descargarPDF: (liquidacionId, tipo = 'liquidacion') =>
    apiClient.get(`${PESCA_BASE}/liquidaciones/${liquidacionId}/pdf?tipo=${tipo}`, { responseType: 'blob' }),

  descargarExcel: (liquidacionId) =>
    apiClient.get(`${PESCA_BASE}/liquidaciones/${liquidacionId}/excel`, { responseType: 'blob' }),

  // ==================== IMPORTACION ====================
  importarExcel: (archivo, rutEmpresa) => {
    const formData = new FormData();
    formData.append('archivo', archivo);
    return apiClient.uploadFile(
      `${PESCA_BASE}/liquidaciones/importar?rut_empresa=${rutEmpresa}`,
      formData
    );
  },
};
